import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';

import {
  SYSTEM_HEALTH_DETAIL_PATH,
  SYSTEM_HEALTH_HISTORY_PATH,
  SYSTEM_HEALTH_STATUS_PATH,
} from '../constants/status-page.constants';
import { StatusPageConfigService } from '../services/status-page-config.service';
import {
  SystemHealthApi,
  SystemHealthDetailResponseDto,
  SystemHealthHistoryResponseDto,
  SystemHealthResponseDto,
} from '../types/system-health-api.types';

/**
 * One endpoint, two shapes, no credentials. The public route needs nothing; the
 * internal route is opened per deployment on the gateway side
 * (`SYSTEM_HEALTH_DETAIL_ENABLED`) and adds service names, probe errors and the
 * source tier. Which one is used is a deployment decision, not a UI one.
 */
@Injectable({ providedIn: 'root' })
export class SystemHealthApiService implements SystemHealthApi {
  private readonly http = inject(HttpClient);
  private readonly config = inject(StatusPageConfigService);

  fetchStatus(): Observable<SystemHealthResponseDto | SystemHealthDetailResponseDto> {
    const { gatewayUrl } = this.config.config();
    if (!this.config.isDetailView()) {
      return this.http.get<SystemHealthResponseDto>(`${gatewayUrl}${SYSTEM_HEALTH_STATUS_PATH}`);
    }

    return this.http.get<SystemHealthDetailResponseDto>(`${gatewayUrl}${SYSTEM_HEALTH_DETAIL_PATH}`);
  }

  /** Last-24-hours outage windows; the route only answers where detail is enabled, so the public view never reaches it. */
  fetchHistory(): Observable<SystemHealthHistoryResponseDto> {
    if (!this.config.isDetailView()) return EMPTY;

    const { gatewayUrl } = this.config.config();
    return this.http.get<SystemHealthHistoryResponseDto>(`${gatewayUrl}${SYSTEM_HEALTH_HISTORY_PATH}`);
  }
}
